import historylist from "./historylist";
import historycontent from "./historycontent";
import keysteplist from "./keysteplist";

export default {
  historylist,
  historycontent,
  keysteplist,
};
